// extracted by mini-css-extract-plugin
export default {"container":"soaePK","title":"egchYj","large":"fygvoc","suggestion":"RQErQY","action":"_5okDGS","iconContainer":"PvAqGj"};